// Native
import { useState } from "react"

// Components
import { Button, ButtonGroup, ModalBody, ModalFooter, useDisclosure, useToast } from "@chakra-ui/react"
import { Alert, Form, Icon, Modal } from "components"

// Config
import { API, Mask } from "config"

// Hooks
import { useWithdraw, useWithdraws } from "hooks"

// Screens
import { Authenticate } from "screens"

export default function Approve({ data, ...props }){

    const toast = useToast()
    const auth = useDisclosure()
    const withdraws = useWithdraws(1)
    const withdraw = useWithdraw(data?.id)
    const [ loading, setLoading ] = useState()
    const [ form, setForm ] = useState({})
    const [ errors, setErrors ] = useState()

    const handleSubmit = async () => {
        setErrors(false)
        setLoading(true)

        try{
            await API.put(`/withdraws/${withdraw.data.id}/approve`, form)
            toast({ title: 'Pedido de saque aprovado.', status: 'success' })
            setForm({})
            withdraw.refetch()
            withdraws.refetch()
            props.onClose()
        }catch(err){
            setErrors(err?.response?.data?.errors)
            toast({ title: 'Não foi possível aprovar o saque.', description: err?.response?.data?.message, status: 'warning' })
        }

        setLoading(false)
    }

    const onChange = ({ target }) => {
        const { name, value } = target
        switch(name){
            case 'value': setForm({...form, [name]: Mask.price(value)}); break;
            default: setForm({...form, [name]: value }); break;
        }
    }

    return(
    <>
    <Modal title={`Aprovar pedido de saque #${withdraw.data?.cod}`} loading={loading} {...props}>
        <ModalBody>
            <Alert status="info" title="Atenção!" children="Após aprovar o pedido de saque, ele entrará na lista para pagamento. Após realizar o pagamento é necessário finalizar o saque anexar o comprovante de transferência." />

            <Form.Form onSubmit={auth.onOpen} mt={4}>
                <Form.Text
                    required
                    isDisabled
                    label="Valor do saque:"
                    name="value"
                    value={form?.value}
                    error={errors?.value}
                    defaultValue={Mask.price(data?.value)}
                    onChange={onChange}
                    size="lg"
                    fontWeight="bold"
                    leftElement="R$"
                    helper={`Lembre sempre de considerar a taxa de saque no valor de R$${Mask.price(withdraw.data?.tax)} ao alterar este valor.`}
                />

                <Form.Textarea
                    label="Observações:"
                    name="comments"
                    value={form?.comments}
                    error={errors?.comments}
                    defaultValue={withdraw.data?.comments}
                    onChange={onChange}
                    isDisabled={loading}
                />
            </Form.Form>
        </ModalBody>
        <ModalFooter>
            <ButtonGroup size="xs" isDisabled={loading}>
                <Button children="Aprovar saque" onClick={auth.onOpen} isLoading={loading} leftIcon={<Icon name="check" />} />
                <Button colorScheme="red" children="Cancelar" onClick={props.onClose} />
            </ButtonGroup>
        </ModalFooter>
    </Modal>

    <Authenticate {...auth} onSuccess={handleSubmit} />
    </>
    )
}